import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../api';

const AdminScan: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    const navigate = useNavigate();
    
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [data, setData] = useState<any>(null);
    const [toggling, setToggling] = useState(false);

    useEffect(() => {
        const fetchScanData = async () => {
            try {
                const res = await api.get(`/scan/${token}`);
                setData(res.data);
            } catch (err: any) {
                setError(err.response?.data?.error || 'Fehler beim Laden');
            } finally {
                setLoading(false);
            }
        };

        if (token) fetchScanData();
    }, [token]);

    const togglePickup = async () => {
        setToggling(true);
        try {
            const res = await api.post(`/scan/${token}/pickup`);
            setData({
                ...data,
                participant: {
                    ...data.participant,
                    picked_up: res.data.picked_up
                }
            });
        } catch (err: any) {
            alert(err.response?.data?.error || 'Fehler beim Speichern');
        } finally {
            setToggling(false);
        }
    };

    if (loading) return <div className="container mt-5 text-center"><div className="spinner-border text-primary"></div></div>;
    
    if (error) return (
        <div className="container mt-5 text-center">
            <div className="alert alert-danger">{error}</div>
            <button className="btn btn-secondary" onClick={() => navigate('/admin')}>Zurück zum Dashboard</button>
        </div>
    );

    if (!data) return null;

    const { participant, event, orderedItems } = data;
    const isPickedUp = participant.picked_up === 1;

    return (
        <div className="container mt-5 mb-5" style={{ maxWidth: '600px' }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Bestell-Abholung</h2>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate('/admin')}>Dashboard</button>
            </div>
            
            <div className={`card shadow-sm border-0 mb-4 ${isPickedUp ? 'bg-success bg-opacity-10' : ''}`}>
                <div className="card-body">
                    <h5 className="card-title text-muted mb-1">{event.title}</h5>
                    <h3 className="card-title fw-bold">{participant.name}</h3>
                    <p className="text-muted">{participant.email}</p>
                    
                    <hr />
                    
                    <h5 className="mb-3">Bestellte Artikel:</h5>
                    {orderedItems && orderedItems.length > 0 ? (
                        <ul className="list-group list-group-flush mb-4 rounded border">
                            {orderedItems.map((item: any, idx: number) => (
                                <li key={idx} className="list-group-item d-flex justify-content-between align-items-center bg-transparent">
                                    <span>{item.name}</span>
                                    <span className="badge bg-primary rounded-pill fs-6 px-3">{item.quantity}x</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className="alert alert-info">Keine Artikel bestellt.</div>
                    )}
                    
                    <div className="d-grid mt-4">
                        <button 
                            className={`btn btn-lg py-3 fw-bold ${isPickedUp ? 'btn-outline-danger' : 'btn-success'}`}
                            onClick={togglePickup}
                            disabled={toggling}
                        >
                            {toggling ? 'Speichere...' : isPickedUp ? '✖ Abholung stornieren' : '✔ Als Abgeholt markieren'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminScan;
